import { Component, EventEmitter, Output, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { CustomersService, ICustomer } from '../../services/customers.service';

@Component({
  selector: 'app-create-customer-modal',
  imports: [ReactiveFormsModule],
  templateUrl: './create-customer-modal.component.html',
  styleUrl: './create-customer-modal.component.css'
})
export class CreateCustomerModalComponent {
  private readonly customersService = inject(CustomersService);
  private readonly formBuilder = inject(FormBuilder);

  protected readonly form = this.formBuilder.nonNullable.group({
    name: ['', [Validators.required]],
    voucher: ['', [Validators.required]],
    uses: [0, [Validators.required, Validators.min(0)]]
  });

  protected triedSubmit = false;
  protected isSaving = false;

  @Output() closed = new EventEmitter<void>();
  @Output() saved = new EventEmitter<void>();

  protected close(): void {
    this.resetForm();
    this.closed.emit();
  }

  protected async submit(event: Event): Promise<void> {
    event.preventDefault();
    this.triedSubmit = true;
    this.form.markAllAsTouched();

    if (this.form.invalid || this.isSaving) {
      return;
    }

    const usesLeft = this.form.controls.uses.value;
    const customer: ICustomer = {
      _id: '',
      name: this.form.controls.name.value.trim(),
      voucher: this.form.controls.voucher.value.trim(),
      usesLeft: Number.isNaN(usesLeft) ? 0 : usesLeft,
      vouchersBought: 0,
      accountsUsingCode: []
    };

    this.isSaving = true;
    try {
      await firstValueFrom(this.customersService.createCustomer(customer));
      this.resetForm();
      this.saved.emit();
    } finally {
      this.isSaving = false;
    }
  }

  private resetForm(): void {
    this.form.reset({
      name: '',
      voucher: '',
      uses: 0
    });
    this.form.markAsPristine();
    this.form.markAsUntouched();
    this.triedSubmit = false;
  }
}
